import { render, staticRenderFns } from "./CreateReserve.vue?vue&type=template&id=cda68aae&scoped=true&"
import script from "./CreateReserve.vue?vue&type=script&lang=js&"
export * from "./CreateReserve.vue?vue&type=script&lang=js&"
import style0 from "./CreateReserve.vue?vue&type=style&index=0&id=cda68aae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda68aae",
  null
  
)

export default component.exports